import { render, staticRenderFns } from "./testing.vue?vue&type=template&id=7a6be8aa&scoped=true&"
import script from "./testing.vue?vue&type=script&lang=js&"
export * from "./testing.vue?vue&type=script&lang=js&"
import style0 from "./testing.vue?vue&type=style&index=0&id=7a6be8aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6be8aa",
  null
  
)

export default component.exports